import { Link } from "react-router-dom";
import { CalendarCheck } from "lucide-react";
import { useFetch } from "../../lib/hooks";
import { StatusBadge } from "./Ui";

const LABEL = { upcoming: "Belum mulai", finished: "Selesai", off: "Libur / di luar hari aktif", active: "Hari aktif" };

export function DayBadge({ r, compact }) {
  if (!r) return null;
  const tone = r.status === "finished" ? "neutral" : r.status === "upcoming" ? "warning" : "success";
  return <StatusBadge testId="rombel-day-badge" tone={tone} label={r.status === "upcoming" ? `Mulai ${r.start}` : r.status === "finished" ? `Selesai (${r.total} hari)` : `Hari ke-${r.day} / ${r.total}${compact ? "" : ` · ${r.percent}%`}`} />;
}

export function RombelTodayPanel() {
  const { data } = useFetch("/planning/rombel-today");
  if (!data?.length) return null;
  return (
    <div className="surface p-5" data-testid="rombel-today-panel">
      <div className="flex items-center justify-between mb-3"><h3 className="section-title flex items-center gap-2"><CalendarCheck className="h-4 w-4 text-emerald-600" />Hari Pendidikan Hari Ini</h3><Link to="/planning" className="text-xs underline text-slate-500">Pagu per Rombel →</Link></div>
      <div className="space-y-2">
        {data.map((r) => (
          <div key={r.group_id} className="flex items-center gap-3" data-testid={`rombel-today-${r.name}`}>
            <span className="w-24 shrink-0 text-sm font-semibold">{r.name}</span><StatusBadge label={r.class_code} tone="indigo" />
            <div className="flex-1 h-2 rounded-full bg-slate-100 overflow-hidden"><div className={`h-full ${r.status === "finished" ? "bg-slate-400" : "bg-emerald-500"}`} style={{ width: `${r.percent}%` }} /></div>
            <DayBadge r={r} compact /><span className="hidden sm:inline text-[11px] text-slate-400 w-40 truncate">{LABEL[r.status]} · {r.students} siswa</span>
          </div>
        ))}
      </div>
    </div>
  );
}
